import { is } from '@didi/webx-js'
import { pagePath } from '@/common/jump'

export const resourceNames = is('miniprogram')
  ? 'didi_applets_dialog_ckxcxhcpsytjtc'
  : 'didipas_dialog_ckdhcpsytjtc'

export const homePageFallingConf = {
  pagePath: pagePath()?.HOME,
  themeConf: {
    panel: {
      border: '2.5px solid #000',
      headerImage:
        'https://dpubstatic.udache.com/static/dpubimg/uze49XQIFn8HbwbuQ2L0_.png',
      backgroundColor: '#FF6C00',
      backgroundImage:
        'https://ut-static.udache.com/webx/sfc/43rvThPCp38H0jXysqs48_wangge.png',
    },
    button: {
      before: {
        text: '立即领取',
        textColor: '#000',
        border: '1.5px solid #000',
        backgroundColor: '#FFF900',
      },
      after: {
        border: '1.5px solid #000',
        backgroundColor: '#F44C24',
      },
    },
    coupon: {
      amountColor: '#FF591D',
      unitColor: '#F5420D',
      nameColor: '#6E3A22',
      remarkColor: '#888',
      couponBg:
        'linear-gradient(151deg, #FFFFFF 21%, rgba(255,255,255,0.35) 59%), linear-gradient(270deg, #FFEEDC 0%, #FFF8F0 97%)',
    },
  },
  params: {
    // 90004 为火车票的 business_id, 但本次准星要求传入 256 (公共业务线)
    business_id: 256,
    channel_id: 1100000001,
    resource_names: resourceNames,
  },
}
